import type { RouteRecordRaw } from 'vue-router'

const virtualEmployeeRoutes: RouteRecordRaw[] = [
  {
    path: 'virtual-employee',
    component: () => import('@/views/virtual-employee/VirtualEmployeeLayout.vue'),
    redirect: '/virtual-employee/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'virtual-employee-dashboard',
        component: () => import('@/views/virtual-employee/VirtualEmployeeDashboard.vue'),
        meta: { title: '虚拟员工价值驾驶舱' },
      },
      {
        path: 'config',
        name: 'virtual-employee-config',
        component: () => import('@/views/virtual-employee/VirtualEmployeeConfig.vue'),
        meta: { title: '虚拟员工配置工作台' },
      },
    ],
  },
]

export default virtualEmployeeRoutes
